import React from 'react';

function Cloud(){
  return (
      <div className="bg-white sm:py-16 text-center">
        <h1 className='text-4xl font-semibold text-gray-900'>This is the <span className='text-red-500'>Cloud PBX</span> page.<p className='text-lg mt-12'>Coming soon.......</p></h1>
      </div>
  );
};

export default Cloud;
